import {
  OnboardingPackageItem,
  OnboardingPlanItem,
} from 'features/Onboarding/modules/PricingPlan/machine/model';

import locales from '../locales';
import { OnboardingPlanDisplay, PaymentCardLimits } from '../types';

const getOnboardingPlanDisplay = (
  item: OnboardingPlanItem | OnboardingPackageItem,
  shouldShowPackagePriceWithVAT: boolean,
  paymentCardLimits: PaymentCardLimits,
): OnboardingPlanDisplay => {
  if (item.__typename === 'OnboardingPackage') {
    return {
      brandColor: item.plan.brandColor,
      brandName: item.plan.brandName,
      customerSupport: item.plan.customerSupport,
      discountPrice: shouldShowPackagePriceWithVAT
        ? item.discountPrice
        : item.discountPriceWithoutVAT,
      features: item.plan.features,
      label: `${locales.packageTitle[item.type]} +\n${item.trialPeriod} ${
        locales.months
      } ${item.plan.brandName}`,
      limits: item.plan.limits,
      packageType: item.type,
      paymentCard: item.plan.paymentCard,
      paymentCeiling:
        paymentCardLimits[item.plan.paymentCard.type as keyof PaymentCardLimits]
          .maxLimitPaymentWeek * 4,
      planPrice: item.plan.priceWithoutVAT,
      price: shouldShowPackagePriceWithVAT
        ? item.basePrice
        : item.basePriceWithoutVAT,
      providerPackageId: item.providerPackageId,
      providerPlanId: item.plan.providerPlanId,
      trialPeriod: item.trialPeriod,
      withdrawalCeiling:
        paymentCardLimits[item.plan.paymentCard.type as keyof PaymentCardLimits]
          .maxLimitAtmMonth,
    };
  }

  return {
    brandColor: item.brandColor,
    brandName: item.brandName,
    customerSupport: item.customerSupport,
    discountPrice: null,
    features: item.features,
    label: item.brandName,
    limits: item.limits,
    packageType: null,
    paymentCard: item.paymentCard,
    paymentCeiling:
      paymentCardLimits[item.paymentCard.type as keyof PaymentCardLimits]
        .maxLimitPaymentWeek * 4,
    planPrice: null,
    price: item.priceWithoutVAT,
    providerPackageId: null,
    providerPlanId: item.providerPlanId,
    trialPeriod: item.trialPeriod,
    withdrawalCeiling:
      paymentCardLimits[item.paymentCard.type as keyof PaymentCardLimits]
        .maxLimitAtmMonth,
  };
};

export default getOnboardingPlanDisplay;
